<template>
    <div v-if="posts" class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
        <div v-for="post in posts" :key="post.id" class="flex flex-col bg-dashboard-primary rounded-xl hover:shadow-md hover:scale-105 duration-300 overflow-hidden">
            <router-link :to="'/hkcmnews/' + post.slug?.name" class="flex flex-col w-full">
                <div class="relative w-full aspect-w-16 aspect-h-9">
                    <img v-if="post.image" :src="post.image" alt="Post Image" class="object-cover h-full w-full" />
                    <img v-else class="object-contain h-full w-full" :src="$asset('/hkcm/images/hkcm-news.png', 'public')" />
                </div>

                <div class="flex flex-col gap-4 p-4">
                    <p class="text-dashboard-primary-grey text-sm">
                        {{ formatDateByRegion($moment(post.published_at)) }}
                    </p>

                    <p class="font-bold text-black text-base">
                        {{ $translate(post.title.de) }}
                    </p>

                    <p class="text-xs line-clamp-5">{{ $translate(post.teaser) }}</p>
                </div>
            </router-link>
        </div>
    </div>
    <div v-else class="w-full">
        <no-item-found :item-name="$t('matching_posts')" link="https://www.youtube.com/channel/UCvLnTGJQthqju38QPtaD64Q" icon="fi fi-rr-graduation-cap" class="w-full" />
    </div>
</template>

<script setup>
import { defineProps, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { formatDateByRegion } from '../../helpers.js';
import NoItemFound from './noItemFound.vue';

const props = defineProps({
    productIds: {
        type: Array,
        required: true
    }
});
const store = useStore();
const posts = ref([]);

const getPosts = async () => {
    if (!props.productIds || !props.productIds.length) {
        return;
    }

    const cachedData = getCachedPosts();

    if (cachedData.length) {
        posts.value = cachedData;

        return posts.value;
    }

    await fetchPosts();
    posts.value = getCachedPosts();

    return posts.value;
};

const getCachedPosts = () => {
    if (!props.productIds) {
        return [];
    }

    return store.getters['posts/getByKey'](props.productIds)?.data || [];
};

const fetchPosts = async () => {
    return await store.dispatch('posts/index', {
        params: {
            'sort[by]': 'published_at',
            'sort[order]': 'desc',
            product_id: props.productIds,
            limit: 6
        }
    });
};

watch(
    () => props.productIds,
    () => {
        getPosts();
    },
    { immediate: true, deep: true }
);

onMounted(async () => {
    posts.value = await getPosts();
});
</script>
